import {Component, Fragment} from "react";
import {NHCPinoutElementLine} from "src/pages/OfferPage/pinouts/NHCPinout/NHCPinoutElementLine";
import { ts } from "src/utils/translate"
import { getFrontendURL } from "src/utils/url";

interface NHCPinoutElementProps {
  key: number;
  page: number;
  dinDevice: any;
  dinDeviceKey: number;
  xOffset: number;
  ipDevices: any[];
}

interface NHCPinoutElementState {
  data: any[];
}

export class NHCPinoutElement extends Component<NHCPinoutElementProps, NHCPinoutElementState> {

  constructor(props: NHCPinoutElementProps) {
    super(props);
    this.state = {
      data: []
    };
  }

  render() {
    const {page, dinDevice, dinDeviceKey, ipDevices} = this.props;

    const image = getFrontendURL() + '/' + dinDevice.image;

    //const image = dinDevice.image;

    const renderedElement = ((page === dinDevice.page) ?
        <image
          x={dinDevice.x_position}
          y={dinDevice.y_position}
          width={dinDevice.original_width}
          height={dinDevice.original_height}
          href={image}
          xlinkHref={image}
          key={dinDeviceKey}
        /> : '');

    let renderNeedGenericIpDeviceText = null;

    const countedDinDeviceElements = dinDevice.elements.length;
    const renderPinoutElementLine = [];

    let startedY1 = 210;
    let startedY2 = 130;

    if (dinDevice.need_usb_to_main_device && page === 1) {
      renderPinoutElementLine.push(
        <NHCPinoutElementLine
          x1={dinDevice.x_position + 115}
          x2={dinDevice.x_position + 115}
          y1={startedY1}
          y2={startedY2}
          text={'Wireless bridge'}
          key={'1000'}
          direction={1}
        />
      )
    }

    if (countedDinDeviceElements && (page === dinDevice.page)) {
      if (dinDevice.name !== 'Wireless smart hub for Niko Home Control') {

        dinDevice.elements.map((dinDeviceElement: any, key: number) => {

          let positionMargin = 0;
          let x1 = dinDevice.x_position
          let x2 = dinDevice.x_position;
          let y1 = startedY1;
          let y2 = startedY2;

          try{
            if (dinDevice.coordinates.length > 0 && dinDevice.coordinates[key]) {
              x1 = dinDevice.coordinates[key]['x1'] + dinDevice.x_position
              x2 = dinDevice.coordinates[key]['x2'] + dinDevice.x_position;
              if (dinDevice.direction === 2) {
                y1 = startedY1 + 243;
                y2 = startedY2 + 233;
              }
            }
          }
          catch(e)
          {
            console.log(dinDevice);
          }

          renderPinoutElementLine.push(
            <NHCPinoutElementLine
                x1={x1}
                x2={x2}
                y1={y1}
                y2={y2}
                text={(typeof dinDeviceElement === 'object' && dinDeviceElement !== null) ? dinDeviceElement.name : dinDeviceElement}
                key={key.toString()} direction={dinDevice.direction}
            />
          )
        })
      }

      if (dinDevice.name === 'Connected controller for Niko Home Control II' && ipDevices && ipDevices.length > 3) {

        let x1 = 138;
        let y1 = 371;

        let y2 = 363;

        const planObjectIds = new Set(dinDevice.elements.map((obj: any) => obj.plan_object_id));
        const filteredIpDevices = ipDevices.filter(obj => !planObjectIds.has(obj.plan_object_id));


        if (page === 1) {
          renderNeedGenericIpDeviceText = (
              <text
                x="20"
                y="560"
                fontSize="14"
                fill="black"
              >
                {
                  ts("nhc_need_switch_after_three_generic_ip_device_warning", "Over 3pcs of IP devices Switch needs to be added manually!")
                }
              </text>
          );
        }
        let x1Middle = 0;
        let y1Middle = 0;
        let x2Middle = 0;
        let y2Middle = 0;
        let j = filteredIpDevices.length;
        let step = 10;
        if (filteredIpDevices.length > 8) {
          step = 5;
        }
        filteredIpDevices.forEach((item, index) => {

          x1Middle = x1;
          y1Middle = y1 + (step * index);
          x2Middle = x1 + (20 * j);
          y2Middle = y1Middle;

          renderPinoutElementLine.push(
            <line
              x1={x1Middle}
              y1={y1Middle}
              x2={x2Middle}
              y2={y2Middle}
              style={{ stroke: "black", strokeWidth : 1 }}
            />
          );

          renderPinoutElementLine.push(
            <NHCPinoutElementLine
              x1={x2Middle}
              x2={x2Middle}
              y1={453}
              y2={y2Middle}
              text={item.name}
              key={'line_' + j}
              direction={2}
            />
          );
          j--;
        })
      }
    }

    const rowElement = (dinDevice.row > 0 && (page === dinDevice.page)) ?
      <text x={dinDevice.x_position} y={dinDevice.y_position - 150}>
        Row {dinDevice.row}
      </text> : '';

    return <Fragment>
      {rowElement}
      {renderedElement}
      {renderNeedGenericIpDeviceText}
      {renderPinoutElementLine}
    </Fragment>
  }
}
